/* eslint-disable */
import { Button, Flex } from "antd";
import { InboxOutlined, SearchOutlined } from '@ant-design/icons';
import { InfinityLineField, InlineField } from "../AccountInfo/AccountInfoCard";
import * as React from "react";
import { useStore } from "../../../../stores/root-store-context";
import { dateValidation } from "../../helpers/dateValidation";
import ResponsiveGrid from "Components/TableMui/ResponsiveGrid";
import { PaginationConfig } from "antd/es/pagination";

export interface ComplianceProps {
    compliance: ComplianceItem,
}

export type ComplianceItem = {
    complianceKey: number,
    inspictionStr: string,
    employee: string,
    createdStr: string,
    closedStr: string,
    rule: string,
    typeDesc: string,
    com_Violation: string,
    active: boolean,
    complianceSequences: ComplianceSequence[],
}

export type ComplianceSequence = {
    actionDate: string,
    sequence: string,
}


const styles = {
    architecturalCard: {
        flex: '1 1 260px',
        minWidth: 0,
        textAlign: 'start' as const,
        alignSelf: 'stretch',
    }
}

    interface ListState {
        page: number;
        pageSize: number;
        field: string | null;
        sortOrder: string | null;
    }

    const DEFAULT_STATE: ListState = {
        page: 1,
        pageSize: 10,
        field: null,
        sortOrder: null,
    };

    const PAGE_SIZE_OPTIONS = [10, 20, 50];

const Compliance: React.FC<ComplianceProps> = ({ compliance }) => {
    const { modalViewerStore } = useStore();
    const cardId = (React as any).useId();

    const complianceSequences = React.useMemo(
        () => (compliance.complianceSequences ?? []).map((el, index) => ({ ...el, key: index })),
        [compliance.complianceSequences]
    );

    const [pagination, setPagination] = React.useState<PaginationConfig>({
        current: DEFAULT_STATE.page,
        pageSize: DEFAULT_STATE.pageSize,
        total: complianceSequences.length,
    });

    const handlePageChange = (current: number, pageSize: number) => {
        setPagination((prev) => ({ ...prev, current, pageSize }));
    };

    const pagedSequences = React.useMemo(() => {
        const pageSize = pagination.pageSize || DEFAULT_STATE.pageSize;
        const current = pagination.current || 1;
        const start = (current - 1) * pageSize;
        return complianceSequences.slice(start, start + pageSize);
    }, [complianceSequences, pagination]);

    const columns = [
        {
            label: "Action Date",
            field: "actionDate",
            flex: 0.3,
            minWidth: 120,
            sortable: false,
            render: (date: string) => dateValidation(date),
        },
        {
            label: "Sequence",
            field: "sequence",
            flex: 1.2,
            minWidth: 200,
            primary: true,
            sortable: false,
        },
        {
            label: "Action",
            field: "action",
            flex: 0.1,
            minWidth: 110,
            sortable: false,
            render: (_: any, row: any) => {
                return row.fileUrl ? <Button data-testid={`ric-compliance-view-btn-${cardId}`} icon={<SearchOutlined />} onClick={() => {
                    const parts = row.fileUrl.split("/");
                    const fileName = parts[parts.length - 1];
                    modalViewerStore.openFileByUrl(row.fileUrl, fileName)
                }}>View</Button> : <></>;
            },
        },
    ];

    return (
        <Flex wrap="wrap" gap="small" style={{ borderBottom: "1px solid lightgray", paddingBottom: 10, paddingTop: 10 }}>
            <div style={styles.architecturalCard}>
                <InlineField label="Resource ID:" value={compliance?.complianceKey?.toString()} />
                <InlineField label="Closed:" value={compliance.closedStr} />
                <InlineField label="Rule:" value={compliance.rule} />
            </div>
            <div style={styles.architecturalCard}>
                <InlineField label="Inspection:" value={compliance.inspictionStr} />
                <InlineField label="Type:" value={compliance.typeDesc} />
            </div>
            <div style={styles.architecturalCard}>
                <InlineField label="Employee:" value={compliance.employee} />
            </div>
            <div style={styles.architecturalCard}>
                <InlineField label="Created:" value={compliance.createdStr} />
            </div>
            <Flex vertical flex={"1 1 100%"} gap="small">
                <InfinityLineField label="Violation:" value={compliance.com_Violation} />
            </Flex>
            <div style={{ flex: "1 1", overflow: "hidden" }}>

                <Flex vertical flex={"1 1 100%"} gap="small">
                  <ResponsiveGrid
                    columns={columns}
                    rows={pagedSequences}
                    getRowId={(row) => row.key}
                    emptyText={"No data."}
                    emptyIcon={<InboxOutlined />}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    server={{
                        page: pagination.current || 1,
                        pageSize: pagination.pageSize || DEFAULT_STATE.pageSize,
                        total: complianceSequences.length,
                        onChange: handlePageChange,
                    }}
                    />
                </Flex>
                
            </div>

        </Flex>
    );
};

export default Compliance